import { render, staticRenderFns } from "./TeachersAward.vue?vue&type=template&id=fbef98ac&scoped=true&"
import script from "./TeachersAward.vue?vue&type=script&lang=js&"
export * from "./TeachersAward.vue?vue&type=script&lang=js&"
import style0 from "./TeachersAward.vue?vue&type=style&index=0&id=fbef98ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbef98ac",
  null
  
)

export default component.exports